import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  isOpenModal: false,
  modalData: null,
  modalType: "",
};
export const slice = createSlice({
  name: "loadingStatus",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setModal: (state, action) => {
      state.isOpenModal = _.get(action, ["payload", "isOpenModal"], false);
      state.modalData = _.get(action, ["payload", "modalData"], null);
      state.modalType = _.get(action, ["payload", "modalType"], "");
    },
  },
});

export const { setModal } = slice.actions;

export default slice.reducer;
